import React, {FC} from 'react';

import {
  ConflictingMergeCardValues,
  ContactDetailsSectionWithConflictsEnum,
} from '../../../helpers/models/cardMergeHelpers';
import {ContactMergeInformationBannerContainer} from '../common/contactMergeInformationBannerContainer';
import {useContactDetailsContext} from '../contactDetailsContext';
import {ContactMergeConflictsBannerContainer} from './contactMergeConflictsBannerContainer';
import {ContactMergeNoConflictsBanner} from './contactMergeNoConflictsBanner';

/*
 * Component.
 */

export const ContactMergeBanners: FC = () => {
  const contactDetailsContext = useContactDetailsContext();
  const totalMergeConflicts = getTotalMergeConflicts(
    contactDetailsContext?.mergeContext?.conflictingMergeValues ?? {},
  );

  return (
    <>
      <ContactMergeInformationBannerContainer />
      {totalMergeConflicts > 0 ? (
        <ContactMergeConflictsBannerContainer totalMergeConflicts={totalMergeConflicts} />
      ) : (
        <ContactMergeNoConflictsBanner />
      )}
    </>
  );
};

/*
 * Helpers.
 */

export const getTotalMergeConflicts = (conflictingMergeValues: ConflictingMergeCardValues) =>
  (conflictingMergeValues[ContactDetailsSectionWithConflictsEnum.HEADER]?.length ?? 0) +
  (conflictingMergeValues[ContactDetailsSectionWithConflictsEnum.CONTACT_INFORMATION]?.length ?? 0);
